/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2022, Bulb Inc. For more information, please email contact@hellobulb.com.
*/

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AeroModule } from 'src/aero/aero.module';
import { TranslocoModule } from '@jsverse/transloco';
import { BulbAeroDialogTranslationProvider } from './translation-provider';
import { SVGIconModule } from '../../app/svg-icon/svg-icon.module';

/**
 * Module to house all Dynamic Dialogs generated through the primeng DynamicDialogService
 * FUTURE: The AeroDialogService and all of the components it renders in modals should
 * be moved here to remove circular dependencies that are blocking us from using StoryBook for
 * these types of modals.
 */
@NgModule({
  declarations: [
  ],
  imports: [
    CommonModule,
    SVGIconModule,
    AeroModule,
    TranslocoModule,
  ],
  providers: [
    BulbAeroDialogTranslationProvider,
  ],
})
export class AeroDialogsModule { }
